import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import BaseMixer from "@/router/views/BaseMixer";
import simplebar from "simplebar-vue";
import { interpret } from "xstate/lib/interpreter";
import reviewMeetingDetailMachine from "../machines/reviewMeetingDetailMachine";
import { PAReviewModule } from "@/store/modules/paReview.module";
import { PAReviewMeetingActionItemModel } from "@/store/models/paReview/paReviewMeetingActionItem";
import ReviewMeetingActionItemUpsert from "./ReviewMeetingActionItemUpsert.vue";
import ReviewMeetingActionItems from "./ReviewMeetingActionItems.vue";
import DeleteComponent from "@/components/deleteComponent.vue";
import ReviewMeetingNotes from "./ReviewMeetingNotes.vue";
let ReviewMeetingDetail = /** @class */ (() => {
    let ReviewMeetingDetail = class ReviewMeetingDetail extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.machine = reviewMeetingDetailMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.actionItem = "";
            this.intervalId = null;
            this.elapsedTimeInSeconds = 0;
            this.actionItemId = "";
        }
        send(event) {
            if (this.machineService) {
                this.machineService.send(event);
            }
        }
        initialize() {
            this.machineService.send({
                type: "GETTING_REVIEW_MEETING_DETAILS",
                reviewId: this.reviewId,
            });
        }
        assignParticipantNames(participants) {
            return participants.map((participant) => {
                const matchingParticipant = this.reviewMeetingParticipants.find((p) => p.id === participant.id);
                if (matchingParticipant) {
                    participant.value = matchingParticipant.name;
                }
                return participant;
            });
        }
        get reviewMeetingDetail() {
            const paReviewMeeting = PAReviewModule.paReviewMeeting;
            if (!paReviewMeeting) {
                return null;
            }
            return {
                ...paReviewMeeting,
                reviewParticipants: this.assignParticipantNames(paReviewMeeting.reviewParticipants),
            };
        }
        get reviewMeetingParticipants() {
            return PAReviewModule.reviewMeetingParticipants;
        }
        get totalTime() {
            if (this.reviewMeetingDetail.isMeetingStarted && !this.reviewMeetingDetail.isMeetingEnded) {
                if (!this.intervalId) {
                    this.startTimer();
                }
                return this.formattedTimeString(this.elapsedTimeInSeconds);
            }
            else {
                this.stopTimer();
                return this.formattedTimeString(0);
            }
        }
        get meetingDuration() {
            const startTime = new Date(this.reviewMeetingDetail.reviewMeetingActualStartDate);
            const endTime = new Date(this.reviewMeetingDetail.reviewMeetingActualEndDate);
            const diff = endTime.getTime() - startTime.getTime();
            const hours = Math.floor(diff / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((diff % (1000 * 60)) / 1000);
            return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
        }
        startTimer() {
            const startTime = new Date(this.reviewMeetingDetail.reviewMeetingActualStartDate).getTime();
            this.intervalId = setInterval(() => {
                const currentTime = Date.now();
                this.elapsedTimeInSeconds = Math.floor((currentTime - startTime) / 1000);
            }, 1000);
        }
        stopTimer() {
            if (this.intervalId) {
                clearInterval(this.intervalId);
                this.intervalId = null;
                this.elapsedTimeInSeconds = 0;
            }
        }
        addActionItem() {
            this.machineService.send({
                type: "ADD_ACTION_ITEM",
            });
            this.actionItem = new PAReviewMeetingActionItemModel();
        }
        saveActionItem(actionItem) {
            actionItem.meetingId = this.reviewMeetingDetail.id;
            this.machineService.send({
                type: "ADDING_ACTION_ITEM",
                actionItem: actionItem,
            });
        }
        editAction(actionItemId) {
            this.actionItem = null;
            this.actionItem = this.reviewMeetingDetail.reviewMeetingActionItems.find((c) => c.id == actionItemId);
            this.machineService.send({
                type: "EDIT_ACTION_ITEM",
            });
        }
        editActionItem(actionItem) {
            this.machineService.send({
                type: "EDITING_ACTION_ITEM",
                actionItem: actionItem,
            });
            this.actionItem = null;
        }
        deleteActionItem(actionItem) {
            this.actionItemId = actionItem;
            this.machineService.send({
                type: "DELETE_ACTION_ITEM",
            });
        }
        deletingActionItem() {
            this.machineService.send({
                type: "DELETING_ACTION_ITEM",
                actionItemId: this.actionItemId,
            });
        }
        completeActionItem(actionItem, needUpdate) {
            this.machineService.send({
                type: "COMPLETING_ACTION_ITEM",
                actionItemId: actionItem,
                needUpdate: needUpdate,
            });
        }
        editMeeting() {
            this.machineService.send({
                type: "EDIT_MEETING",
            });
            this.$emit("edit-meeting", this.reviewMeetingDetail.id);
        }
        cancel() {
            this.actionItem = null;
            this.machineService.send({
                type: "CANCEL",
            });
        }
        startMeeting() {
            this.machineService.send({
                type: "START_MEETING",
                meetingId: this.reviewMeetingDetail.id,
            });
        }
        endMeeting() {
            this.machineService.send({
                type: "END_MEETING",
                meetingId: this.reviewMeetingDetail.id,
            });
        }
        deleteMeeting() {
            this.machineService.send({
                type: "DELETE_MEETING",
            });
        }
        deletingMeeting() {
            this.machineService.send({
                type: "DELETING_MEETING",
                meetingId: this.reviewMeetingDetail.id,
            });
        }
        addNotes() {
            this.machineService.send({
                type: "MEETING_NOTES",
            });
        }
        closeMeeting() {
            this.machineService.send({
                type: "CLOSE_MEETING",
            });
        }
        closingMeeting() {
            this.machineService.send({
                type: "CLOSING_MEETING",
                meetingId: this.reviewMeetingDetail.id,
            });
        }
        notify() {
            this.$emit("notify", this.state.context.reviewId);
        }
        stopLoading() {
            this.$emit("stopLoading");
        }
        closePopUp() {
            var popover = this.$refs.meeetingPopOver;
            if (popover && popover.$_toolpop && typeof popover.$_toolpop.hide === "function") {
                popover.$_toolpop.hide();
            }
        }
        sanitizeHtml(html) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const anchorTags = doc.querySelectorAll("a");
            anchorTags.forEach((tag) => {
                tag.setAttribute("target", "_blank");
            });
            return doc.documentElement.innerHTML;
        }
        created() {
            this.initialize();
            this.machineService.start();
            this.machineService.onTransition((state) => {
                var previousState = this.state;
                this.state = state;
                if (state.matches("idle") && previousState.matches("loadedMeetingDetails.deletingMeeting")) {
                    this.notify();
                }
                if (state.matches("loadedMeetingDetails.idle") && previousState.matches("getMeetingDetails")) {
                    this.stopLoading();
                }
            });
        }
        destroyed() {
            PAReviewModule.ClearReviewMeeting();
            this.machineService.stop();
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], ReviewMeetingDetail.prototype, "reviewId", void 0);
    ReviewMeetingDetail = __decorate([
        Component({
            name: "ReviewMeetingDetail",
            components: {
                Loader,
                ReviewMeetingActionItemUpsert,
                ReviewMeetingActionItems,
                DeleteComponent,
                ReviewMeetingNotes,
                simplebar,
            },
        })
    ], ReviewMeetingDetail);
    return ReviewMeetingDetail;
})();
export default ReviewMeetingDetail;
